<template>
    <section class="m-industry-hy-form2">
        <label class="m-industry-label1">
            <span class="u-industry-name5">研究机构全称：</span>
            <div class="m-industry-input2">
                <el-input placeholder="研究机构全称" v-model="form.name" clearable></el-input>
            </div>
        </label>
        <div class="m-industry-label1">
            <div class="clearfix">
                <label class="fl">
                    <span class="u-industry-name1">分析师人数：</span>
                    <div class="m-industry-input1">
                        <el-input-number
                            v-model="form.analysts_num"
                            controls-position="right"
                            :step="1"
                            :max="100000"
                        ></el-input-number>&nbsp;人
                    </div>
                </label>
                <label class="fl">
                    <span class="u-industry-name1">研究行业：</span>
                    <div class="m-industry-input1">
                        <el-input-number
                            v-model="form.hy_num"
                            controls-position="right"
                            :step="1"
                            :max="100000"
                        ></el-input-number>&nbsp;个
                    </div>
                </label>
            </div>
        </div>
        <div class="m-industry-label1">
            <div class="clearfix">
                <label class="fl">
                    <span class="u-industry-name1">联系人姓名：</span>
                    <div class="m-industry-input1">
                        <el-input placeholder="请输入姓名" v-model="form.contacts_name" clearable></el-input>
                    </div>
                </label>
                <label class="fl">
                    <span class="u-industry-name1">联系方式：</span>
                    <div class="m-industry-input1">
                        <el-input placeholder="请输入联系方式" v-model="form.contacts_phone" clearable></el-input>
                    </div>
                </label>
            </div>
        </div>

        <label class="m-industry-label1">
            <span class="u-industry-name6">特色研究内容描述（此内容将部分展示在最终获奖证明描述中）：</span>
            <div class="m-industry-input2">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.desc"
                ></el-input>
            </div>
        </label>
        <p class="u-industry-des4">提示：由每家研究自行上报，申报理由可以是在某一行业的突出优势，也可以是深耕区域市场、对所在地域产业有深入研究。</p>
        <div class="m-industry-box3">
            <a class="u-industry-btn2 fl" href="javascript:;" @click="postApply">提交</a>
            <a
                :class="['u-industry-btn2','fr',!isPrint ? 'unclick' : '']"
                href="javascript:;"
                @click="jumpAbout"
            >预览</a>
        </div>
    </section>
</template>

<script>
export default {
    name: "Form2",
    data() {
        return {
            // tagsArr: {},
            active: 0,
            // qsName: "",
            // industry: "",
            // industryDesc: "",
            form: {
                name: "",
                analysts_num: "",
                hy_num: "",
                contacts_name: "",
                contacts_phone: "",
                desc: ""
            },
            isPrint: 0
        };
    },
    created() {
        // this.getTags();
        this.getLists();
    },
    methods: {
        // getTags() {
        //     var _this = this;
        //     let param = {
        //         url:
        //             "//support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.getConfList",
        //         acode: sessionStorage.getItem("acode")
        //             ? sessionStorage.getItem("acode")
        //             : "",
        //         atype: "qs",
        //         type: "hy"
        //     };
        //     // console.log(param);
        //     // 发送 POST 请求
        //     this.$jsonp(param.url, {
        //         acode: "zzzz_u",
        //         // acode: param.acode,
        //         atype: param.atype,
        //         type: param.type
        //     })
        //         .then(function(response) {
        //             // console.log(response);
        //             if (response.result.status.code == 0) {
        //                 let datas = response.result.data;
        //                 let userDatas = datas.user;
        //                 let adminDatas = datas.admin;
        //                 let allDatas = adminDatas
        //                     ? userDatas.concat(adminDatas)
        //                     : userDatas;
        //                 // console.log(userDatas, adminDatas);
        //                 _this.tagsArr = allDatas;
        //                 // _this.tagsArr = userDatas;
        //                 // _this.tagsAdminArr = adminDatas;
        //                 let cur = _this.active || 0;
        //                 _this.getLists(cur);
        //             }
        //         })
        //         .catch(function(error) {
        //             console.log(error);
        //         });
        // },
        getLists(index, ele) {
            var _this = this;
            // var el = ele ? ele.currentTarget : "";
            // _this.industry = el ? el.textContent : "宏观经济";
            // // console.log(el);
            // _this.industryDesc = el ? el.dataset.des : "";

            // _this.active = index;
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.getInstitution",
                // http://support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.getAnalyst?acode=zzzz&atype=qs
                // ?acode=ajzq_020235f9c2af&atype=qs&hy_id=1
                acode: sessionStorage.getItem("acode")
                    ? sessionStorage.getItem("acode")
                    : "",
                atype: "qs"
                // hy_id: index + 1
            };
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype
                // hy_id: param.hy_id
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data;

                        let adapterDatas = _this.adapter(datas.hy);
                        // console.log(adapterDatas);
                        _this.form = adapterDatas;
                        _this.isPrint = datas.qs.hy_total;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        adapter(data) {
            // if (!data.length) {
            if (!data) {
                return {
                    name: "",
                    analysts_num: "",
                    hy_num: "",
                    contacts_name: "",
                    contacts_phone: "",
                    desc: ""
                };
            }

            // return data.reduce(function(per, cur) {
            // var analyst_cert_time = new Date(data.analyst_cert_time * 1);
            var per = {
                name: data.name || "",
                analysts_num: data.analysts_num * 1 || "",
                hy_num: data.hy_num * 1 || "",
                // analyst_phone: Number(data.analyst_phone) || 1,
                contacts_name: data.contacts_name || "",
                contacts_phone: data.contacts_phone || "",
                desc: data.desc || ""
            };

            return per;
            // }, []);
        },
        postApply() {
            var _this = this,
                analyst_cert_time_str = new Date(
                    this.form.analyst_cert_time
                ).getTime();
            // 发送 POST 请求

            let url =
                "//support.finance.sina.com.cn/service/api/openapi.php/JinQi2020Service.saveInstitution";
            let param = new URLSearchParams();
            param.append("acode", sessionStorage.getItem("acode"));
            param.append("atype", "qs");

            param.append("name", this.form.name);
            param.append("analysts_num", this.form.analysts_num);
            param.append("hy_num", this.form.hy_num);
            param.append("contacts_name", this.form.contacts_name);
            param.append("contacts_phone", this.form.contacts_phone);
            param.append("desc", this.form.desc);

            // param.append("hy_id", this.active + 1);
            // param.append("hy_id", this.form.hy_name);
            // param.append("hy_name", this.form.hy_name);
            // param.append("report_brief", this.form.report_brief);
            this.axios({
                method: "POST",
                url: url,
                data: param
            })
                .then(function(response) {
                    let data = response.data.result;
                    if (data.status.code == 0) {
                        _this.$message({
                            message:
                                "恭喜你，报名成功！请填写其他行业报名或预览填写内容！",
                            type: "success"
                        });
                        // _this.getTags();
                    } else {
                        let msg = data.status.msg;
                        _this.$message({
                            message: msg,
                            type: "warning"
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        jumpAbout() {
            if (!this.isPrint) {
                return;
            }
            this.$confirm(
                "请提交当前填写内容后预览，预览内容为所有参选行业报名情况！",
                "提示",
                {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    this.$router.push({ path: "about" });
                })
                .catch(() => {
                    // this.$message({
                    //     type: "info",
                    //     message: "已取消删除"
                    // });
                });
        }
    }
};
</script>